import { Stores } from "arv-extends";

class PromotionsStoreAction extends Stores.PromotionsStoreClass {}

export default PromotionsStoreAction;
